import {
  AppState,
  DictionaryDTO,
  NewProposalReason,
  OpportunityStage,
  ProposalItemVm,
} from '@/types';

export const selectPossibleOrderStatuses = (state: AppState): DictionaryDTO[] => {
  return state.dictionaries.orderStatuses || [];
};

const enumToDictionary = (enumeration): DictionaryDTO[] => {
  const keys = Object.keys(enumeration).filter(key => Number.isNaN(Number(key)));

  return keys.map(key => {
    return {
      id: enumeration[key],
      title: key,
      code: key,
    };
  });
};

export const selectOpportunityStages = (): DictionaryDTO[] => {
  return enumToDictionary(OpportunityStage);
};

export const selectRequestNewProposalReasons = (): DictionaryDTO[] => {
  return enumToDictionary(NewProposalReason);
};

export const selectProposalItems = (state: AppState): ProposalItemVm[] => {
  return state.dictionaries.proposalItems || [];
};
